import apiService from './api';

const actPricingService = {
  getSummary() {
    return apiService.get('/act-pricing/summary');
  },

  listConsultations(params = {}) {
    return apiService.get('/act-pricing/consultations', { params });
  },

  updateConsultation(id, payload) {
    return apiService.patch(`/act-pricing/consultations/${id}`, payload);
  },

  listExams(params = {}) {
    return apiService.get('/act-pricing/exams', { params });
  },

  updateExam(id, payload) {
    return apiService.patch(`/act-pricing/exams/${id}`, payload);
  },

  listReferrals(params = {}) {
    return apiService.get('/act-pricing/referrals', { params });
  },

  updateReferral(id, payload) {
    return apiService.patch(`/act-pricing/referrals/${id}`, payload);
  },

  listNursingCare(params = {}) {
    return apiService.get('/act-pricing/nursing-care', { params });
  },

  updateNursingCare(id, payload) {
    return apiService.patch(`/act-pricing/nursing-care/${id}`, payload);
  },

  listNursingInjections(params = {}) {
    return apiService.get('/act-pricing/nursing-injections', { params });
  },

  updateNursingInjection(id, payload) {
    return apiService.patch(`/act-pricing/nursing-injections/${id}`, payload);
  },

  listNursingTests(params = {}) {
    return apiService.get('/act-pricing/nursing-tests', { params });
  },

  updateNursingTest(id, payload) {
    return apiService.patch(`/act-pricing/nursing-tests/${id}`, payload);
  },

  listVaccines(params = {}) {
    return apiService.get('/act-pricing/vaccines', { params });
  },

  updateVaccine(id, payload) {
    return apiService.patch(`/act-pricing/vaccines/${id}`, payload);
  },

  listFamilyPlanning(params = {}) {
    return apiService.get('/act-pricing/family-planning', { params });
  },

  updateFamilyPlanning(id, payload) {
    return apiService.patch(`/act-pricing/family-planning/${id}`, payload);
  }
};

export default actPricingService;
